import { createFileRoute } from '@tanstack/react-router';
import { InfrastructureCostsPage } from '@/pages/admin/infrastructure-costs';
import { infrastructureCostsSearchSchema } from '@/routes/-shared/infrastructureCostsSearchSchema';

export const Route = createFileRoute('/admin/_layout/infrastructure-costs/')({
  component: InfrastructureCostsPage,
  validateSearch: infrastructureCostsSearchSchema,
});
